import { render, staticRenderFns } from "./LoanTakeBack.vue?vue&type=template&id=791eed85&scoped=true&"
import script from "./LoanTakeBack.vue?vue&type=script&lang=ts&"
export * from "./LoanTakeBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791eed85",
  null
  
)

export default component.exports